(function () {
  var LINK_PROPERTY = '_Lien redimensionnement';
  var FEE_ROLE_PROPERTY = '_Frais de redimensionnement';
  var SYNC_SOURCE = 'ring-size-fee-sync';
  var running = false;

  function changeUrl() {
    var base = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url.replace(/\/add(\.js)?$/, '') : '/cart';
    return base + '/change.js';
  }

  function removeLine(key) {
    return fetch(changeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function (response) {
      return response.json();
    });
  }

  function cleanupOrphanFees() {
    if (running) return;
    running = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var mainLinks = {};
        var feeLines = [];

        (cart.items || []).forEach(function (item) {
          var props = item.properties || {};
          var link = props[LINK_PROPERTY];
          if (!link) return;
          if (props[FEE_ROLE_PROPERTY]) {
            feeLines.push({ link: link, key: item.key });
          } else {
            mainLinks[link] = true;
          }
        });

        var orphans = feeLines.filter(function (fee) {
          return !mainLinks[fee.link];
        });

        if (orphans.length === 0) {
          running = false;
          return;
        }

        Promise.all(orphans.map(function (fee) { return removeLine(fee.key); }))
          .then(function () {
            running = false;
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: SYNC_SOURCE });
            }
          })
          .catch(function () {
            running = false;
          });
      })
      .catch(function () {
        running = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === SYNC_SOURCE) return;
        cleanupOrphanFees();
      });
    }
    cleanupOrphanFees();
  });
})();
